import { useParams } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN6 from "../../components/Modal/ModalComponentN6";
import Loading from "../../components/Loading";

export default function SearchN6Table() {
    const params = useParams();
    const [N6Data, setN6Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN1Records = useCallback(() => {
        api.get(`/search/n6?filter[search]=${params?.name}`)
            .then((response) => {
                const data = response.data;
                setN6Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name]);

    useEffect(() => {
        if (params?.name) {
            fetchN1Records();
        }
    }, [params, fetchN1Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Primer Validation</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Primer Name
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Primer ID
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Purification
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Scale
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N6Data.length > 0 ? (
                            N6Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.primer_name}
                                        </th>
                                        <td className="font-monospace text-end">{item?.primer_id}</td>
                                        <td className="font-monospace text-end">{item?.purification}</td>
                                        <td className="font-monospace text-end">{item?.scale}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={5}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="font-monospace">Primer Name : {dataModal?.primer_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN6 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
